import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { MetricService } from '../metric.service';
import { MetricBaseAbstract } from '../metric-base.abstract';
import { combineLatestWith } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'app-ya-metric',
    templateUrl: './ya-metric.component.html',
    standalone: true
})
export class YaMetricComponent extends MetricBaseAbstract {
  constructor(
    private metrica: MetricService,
    private router: Router
  ) {super()}

  protected override onRunMetric(codes: string[]): void {
    this.metrica.runYAM(codes);

    this.router.events.pipe(
      combineLatestWith(this.metrica.utmParams$),
      untilDestroyed(this)
    ).subscribe(([event, utmParams]) => {
      if (event instanceof NavigationEnd) {
        this.metrica.hitYandex(window.location.href, utmParams);
      }
    });
  }
}
